export const SectorType = Object.freeze({
  agriculture: '1',
  automotive: '2',
  businesServices: '3',
  charities: '29',
  construction: '4',
  courier: '5',
  distribution: '6',
  education: '27',
  financialServices: '7',
  haulage: '8',
  healthcare: '9',
  hotels: '10',
  importExport: '11',
  itRelated: '12',
  manufacturing: '13',
  mediaEntertainment: '31',
  printPublishing: '14',
  professionalServices: '15',
  property: '16',
  recruitment: '17',
  retail: '18',
  securityServices: '19',
  trade: '20',
  transportation: '21',
  wholesale: '22',
  other: '23',
  none: '24',
});

export const SectorLabelToType = Object.freeze({
  AGRICULTURE: '1',
  AUTOMOTIVE: '2',
  BUSINESS_SERVICES: '3',
  CHARITIES: '29',
  CONSTRUCTION: '4',
  COURIER: '5',
  DISTRIBUTION: '6',
  EDUCATION: '27',
  FINANCIAL_SERVICES: '7',
  HAULAGE: '8',
  HEALTHCARE_CARE: '9',
  HOTELS_HOUSE: '10',
  IMPORT_EXPORT: '11',
  IT_RELATED: '12',
  MANUFACTURING: '13',
  MEDIA_AND_ENTERTAINMENT: '31',
  PRINT_PUBLISHING: '14',
  PROFESSIONAL_SERVICES: '15',
  PROPERTY: '16',
  RECRUITMENT: '17',
  RETAIL: '18',
  SECURITY_SERVICES: '19',
  TRADE: '20',
  TRANSPORTATION: '21',
  WHOLESALE: '22',
  OTHER: '23',
  NONE: '24',
});

export const SectorTypeLabel = Object.freeze({
  [SectorType.agriculture]: 'Agriculture',
  [SectorType.automotive]: 'Automotive',
  [SectorType.businesServices]: 'Business Services',
  [SectorType.charities]: 'Charities',
  [SectorType.construction]: 'Construction',
  [SectorType.courier]: 'Courier',
  [SectorType.distribution]: 'Distribution',
  [SectorType.education]: 'Education',
  [SectorType.financialServices]: 'Financial Services',
  [SectorType.haulage]: 'Haulage',
  [SectorType.healthcare]: 'Healthcare/Care',
  [SectorType.hotels]: 'Hotels/Guest House/Public House',
  [SectorType.importExport]: 'Import/Export',
  [SectorType.itRelated]: 'IT Related',
  [SectorType.manufacturing]: 'Manufacturing',
  [SectorType.mediaEntertainment]: 'Media & Entertainment',
  [SectorType.printPublishing]: 'Print/Publishing',
  [SectorType.professionalServices]: 'Professional Services',
  [SectorType.property]: 'Property',
  [SectorType.recruitment]: 'Recruitment',
  [SectorType.retail]: 'Retail',
  [SectorType.securityServices]: 'Security Services',
  [SectorType.trade]: 'Trade',
  [SectorType.transportation]: 'Transportation',
  [SectorType.wholesale]: 'Wholesale',
  [SectorType.other]: 'Other',
  [SectorType.none]: 'None',
});

export const SectorTypeLabelShort = Object.freeze({
  [SectorType.agriculture]: 'Agriculture',
  [SectorType.automotive]: 'Automotive',
  [SectorType.businesServices]: 'Business Services',
  [SectorType.charities]: 'Charities',
  [SectorType.construction]: 'Construction',
  [SectorType.courier]: 'Courier',
  [SectorType.distribution]: 'Distribution',
  [SectorType.education]: 'Education',
  [SectorType.financialServices]: 'Financial Services',
  [SectorType.haulage]: 'Haulage',
  [SectorType.healthcare]: 'Healthcare',
  [SectorType.hotels]: 'Hospitality',
  [SectorType.importExport]: 'Import/Export',
  [SectorType.itRelated]: 'IT Related',
  [SectorType.manufacturing]: 'Manufacturing',
  [SectorType.mediaEntertainment]: 'Media',
  [SectorType.printPublishing]: 'Print/Publishing',
  [SectorType.professionalServices]: 'Professional Services',
  [SectorType.property]: 'Property',
  [SectorType.recruitment]: 'Recruitment',
  [SectorType.retail]: 'Retail',
  [SectorType.securityServices]: 'Security Services',
  [SectorType.trade]: 'Trade',
  [SectorType.transportation]: 'Transportation',
  [SectorType.wholesale]: 'Wholesale',
  [SectorType.other]: 'Other',
  [SectorType.none]: 'None',
});

export function toOptions() {
  return Object.values(SectorType).map((value) => ({ label: SectorTypeLabel[value], value }));
}
